import { IContinuousDrillingObligation } from '../../interfaces/icontinuous-drilling-obligation';
import { ContinuousDrillingObligationTrigger } from '../continuous-drilling-obligation-trigger';
import { Lease } from '../lease';
import { TargetFormation } from '../target-formation';

export class ContinuousDrillingObligationBase {
  ContinuousDrillingObligationId: number;
  LeaseId: number;
  TargetFormationId: number | null;
  HBP: boolean | null;
  PercentComplete: number | null;
  Definition: string | null;
  FromCDOTriggerId: number | null;
  ToCDOTriggerId: number | null;
  Override: boolean | null;
  Days: number | null;
  LandResponse: string | null;
  Landman: string | null;
  CDOComments: string | null;
  IsCriticalDate: boolean;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;

  Lease?: Lease;
  TargetFormation?: TargetFormation;
  FromCDOTrigger?: ContinuousDrillingObligationTrigger;
  ToCDOTrigger?: ContinuousDrillingObligationTrigger;

  constructor(item?: IContinuousDrillingObligation) {
    if (item) {

      this.ContinuousDrillingObligationId = item.ContinuousDrillingObligationId;
      this.LeaseId = item.LeaseId;
      this.TargetFormationId = item.TargetFormationId;
      this.HBP = item.HBP;
      this.PercentComplete = item.PercentComplete;
      this.Definition = item.Definition;
      this.FromCDOTriggerId = item.FromCDOTriggerId;
      this.ToCDOTriggerId = item.ToCDOTriggerId;
      this.Override = item.Override;
      this.Days = item.Days;
      this.LandResponse = item.LandResponse;
      this.Landman = item.Landman;
      this.CDOComments = item.CDOComments;
      this.IsCriticalDate = item.IsCriticalDate;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;

      this.Lease = new Lease(item.Lease);
      this.TargetFormation = new TargetFormation(item.TargetFormation);
      this.FromCDOTrigger = new ContinuousDrillingObligationTrigger(item.FromCDOTrigger);
      this.ToCDOTrigger = new ContinuousDrillingObligationTrigger(item.ToCDOTrigger);
    }
  }
}